export const DO_GET_ACCOUNT = 'DO_GET_ACCOUNT';

export const DO_GET_ARTICLE = 'DO_GET_ARTICLE';
export const DO_GET_ARTICLES = 'DO_GET_ARTICLES';

export const DO_GET_BELIEF_STATEMENTS = 'DO_GET_BELIEF_STATEMENTS';

export const DO_GET_CHANNEL = 'DO_GET_CHANNEL';
export const DO_GET_CHANNELS = 'DO_GET_CHANNELS';

export const DO_GET_COLLECTIONS = 'DO_GET_COLLECTIONS';

export const DO_GET_EPISODE = 'DO_GET_EPISODE';
export const DO_GET_EPISODES = 'DO_GET_EPISODES';

export const DO_GET_EPISODE_COLLECTION = 'DO_GET_EPISODE_COLLECTION';
export const DO_GET_EPISODE_COLLECTIONS = 'DO_GET_EPISODE_COLLECTIONS';

export const DO_CREATE_EVENT_REGISTRATION = 'DO_CREATE_EVENT_REGISTRATION';

export const DO_GET_EVENT = 'DO_GET_EVENT';
export const DO_GET_EVENTS = 'DO_GET_EVENTS';

export const DO_CREATE_MEMBER = 'DO_CREATE_MEMBER';
export const DO_GET_MEMBER = 'DO_GET_MEMBER';
export const DO_UPDATE_MEMBER = 'DO_UPDATE_MEMBER';

export const DO_GET_MINISTRY = 'DO_GET_MINISTRY';
export const DO_GET_MINISTRIES = 'DO_GET_MINISTRIES';

export const DO_CREATE_ORDER = 'DO_CREATE_ORDER';

export const DO_GET_PAGE = 'DO_GET_PAGE';

export const DO_GET_SERVICES = 'DO_GET_SERVICES';

export const DO_GET_SPEAKER = 'DO_GET_SPEAKER';
export const DO_GET_SPEAKERS = 'DO_GET_SPEAKERS';

export const DO_GET_STAFF_MEMBER = 'DO_GET_STAFF_MEMBER';
export const DO_GET_STAFF_MEMBERS = 'DO_GET_STAFF_MEMBERS';

export const DO_GET_WAIVER = 'DO_GET_WAIVER';
